import React from 'react';
import './footer.scss';

const Footer = () => {
  return (
    <footer>
      powered by iPOS
    </footer>
  );
};

export default Footer;
